import Accordion from "react-bootstrap/Accordion";
import "../styles/AerospaceFaqSection.css";
import { useEffect } from "react";
import React, { useState } from "react";
import TableNo8 from "../Tables/TableNo8";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import TableNo14 from "../Tables/TableNo14";
import TableNo9 from "../Tables/TableNo9";
import TableNo17 from "../Tables/TableNo17";
import TableNo18 from "../Tables/TableNo18";
import TableNo19 from "../Tables/TableNo19";
import TableNo20 from "../Tables/TableNo20";
import TableNo23 from "../Tables/TableNo23";
import TableNo10 from "../Tables/TableNo10";
import TableNo21 from "../Tables/TableNo21";
import TableNo22 from "../Tables/TableNo22";
import TableNo24 from "../Tables/TableNo24";
import TableNo25 from "../Tables/TableNo25";
import TableNo26 from "../Tables/TableNo26";
import TableNo27 from "../Tables/TableNo27";
import TableNo28 from "../Tables/TableNo28";
import TableNo29 from "../Tables/TableNo29";
import TableNo30 from "../Tables/TableNo30";
import TableNo31 from "../Tables/TableNo31";
import TableNo32 from "../Tables/TableNo32";
import TableNo33 from "../Tables/TableNo33";
import TableNo34 from "../Tables/TableNo34";
import TableNo35 from "../Tables/TableNo35";
import TableNo36 from "../Tables/TableNo36";
import TableNo37 from "../Tables/TableNo37";
import TableNo11 from "../Tables/TableNo11";
import TableNo13 from "../Tables/TableNo13";
import TableNo16 from "../Tables/TableNo16";
import TableNo12 from "../Tables/TableNo12";
import TableNo15 from "../Tables/TableNo15";
import { useLocation } from "react-router-dom";

export const FaqSection = ({ searchTerm }) => {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("Employment-Trend");

  const [expandedQuestion, setExpandedQuestion] = useState(null);
  const [expandedSubQuestion, setExpandedSubQuestion] = useState(null);

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const tab = searchParams.get("tab");
    const question = searchParams.get("question");

    if (tab) setActiveTab(tab);
    if (question) setExpandedQuestion(decodeURIComponent(question));
  }, [location.search]);

  const handleTabSelect = (tabKey) => {
    setActiveTab(tabKey);
    setExpandedQuestion(null); // Reset expanded question when switching tabs
  };

  const [isOpen1, setIsOpen1] = useState(false);
  const [isOpen2, setIsOpen2] = useState(false);
  const [isOpen3, setIsOpen3] = useState(false);
  const [isOpen4, setIsOpen4] = useState(false);
  const [isOpen5, setIsOpen5] = useState(false);
  const [isOpen6, setIsOpen6] = useState(false);
  const [isOpen7, setIsOpen7] = useState(false);
  const [isOpen8, setIsOpen8] = useState(false);
  const [isOpen9, setIsOpen9] = useState(false);
  const [isOpen10, setIsOpen10] = useState(false);
  const [isOpen11, setIsOpen11] = useState(false);
  const [isOpen12, setIsOpen12] = useState(false);
  const [isOpen13, setIsOpen13] = useState(false);
  const [isOpen14, setIsOpen14] = useState(false);
  const [isOpen15, setIsOpen15] = useState(false);
  const [isOpen16, setIsOpen16] = useState(false);

  const [isOpen17, setIsOpen17] = useState(false);
  const [isOpen18, setIsOpen18] = useState(false);
  const [isOpen19, setIsOpen19] = useState(false);
  const [isOpen20, setIsOpen20] = useState(false);
  const [isOpen21, setIsOpen21] = useState(false);
  const [isOpen22, setIsOpen22] = useState(false);
  const [isOpen23, setIsOpen23] = useState(false);
  const [isOpen24, setIsOpen24] = useState(false);
  const [isOpen25, setIsOpen25] = useState(false);
  const [isOpen26, setIsOpen26] = useState(false);
  const [isOpen27, setIsOpen27] = useState(false);
  const [isOpen28, setIsOpen28] = useState(false);
  const [isOpen29, setIsOpen29] = useState(false);
  const [isOpen30, setIsOpen30] = useState(false);
  const [isOpen31, setIsOpen31] = useState(false);
  const [isOpen32, setIsOpen32] = useState(false);
  const [currentOpenIndex, setCurrentOpenIndex] = useState(null);

  const isOpenStates = [
    setIsOpen1,
    setIsOpen2,
    setIsOpen3,
    setIsOpen4,
    setIsOpen5,
    setIsOpen6,
    setIsOpen7,
    setIsOpen8,
    setIsOpen9,
    setIsOpen10,
    setIsOpen11,
    setIsOpen12,
    setIsOpen13,
    setIsOpen14,
    setIsOpen15,
    setIsOpen16,
    setIsOpen17,
    setIsOpen18,
    setIsOpen19,
    setIsOpen20,
    setIsOpen21,
    setIsOpen22,
    setIsOpen23,
    setIsOpen24,
    setIsOpen25,
    setIsOpen26,
    setIsOpen27,
    setIsOpen28,
    setIsOpen29,
    setIsOpen30,
    setIsOpen31,
    setIsOpen32,
  ];

  const handleSetOpen = (openIndex, currentOpenIndex) => {
    if (openIndex === currentOpenIndex) {
      // If already open, close all
      isOpenStates.forEach((setFn) => setFn(false));
    } else {
      // Close all, then open selected
      isOpenStates.forEach((setFn, i) => {
        setFn(i === openIndex - 1);
      });
    }
  };

  return (
    <div className="w-[90vw] h-auto p-1 rounded-lg  justify-center items-center mx-auto">
      <Tabs
        id="controlled-tab-example"
        className="tabs"
        activeKey={activeTab}
        onSelect={handleTabSelect}
      >
        {/* employment trend */}

        <Tab
          eventKey="Employment-Trend"
          title="Employment Trend"
          id="Employment-Trend"
        >
          <Accordion>
            <Accordion.Item
              eventKey="What are the total employment trends in Utah's manufacturing sector from 2018 to 2024?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(1, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 1 ? null : 1);
                setExpandedQuestion(
                  "What are the total employment trends in Utah's manufacturing sector from 2018 to 2024?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  1. What are the total employment trends in Utah's
                  manufacturing sector from 2018 to 2024?
                </span>
                {/* <span className="ms-auto !text-3xl">{isOpen1 ? "–" : "+"}</span> */}
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 1 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <TableNo8 />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey="How has the female employment share in the manufacturing industry changed in 2024 compared to 2018?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(2, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 2 ? null : 2);
                setExpandedQuestion(
                  "How has the female employment share in the manufacturing industry changed in 2024 compared to 2018?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  2. How has the female employment share in the manufacturing
                  industry changed in 2024 compared to 2018?
                </span>
                {/* <span className="ms-auto !text-3xl">{isOpen1 ? "–" : "+"}</span> */}
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 2 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <TableNo9 />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey="What percentage of the total workforce in 2024 is male in Utah's manufacturing sector?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(3, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 3 ? null : 3);
                setExpandedQuestion(
                  "What percentage of the total workforce in 2024 is male in Utah's manufacturing sector?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  3. What percentage of the total workforce in 2024 is male in
                  Utah's manufacturing sector?
                </span>
                {/* <span className="ms-auto !text-3xl">{currentOpenIndex === 1 ? "–" : "+"}</span> */}
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 3 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <TableNo17 />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey="What are the differences in employment counts between males and females in Utah manufacturing from 2018 to 2024?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(4, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 4 ? null : 4);
                setExpandedQuestion(
                  "What are the differences in employment counts between males and females in Utah manufacturing from 2018 to 2024?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  4. What are the differences in employment counts between males
                  and females in Utah manufacturing from 2018 to 2024?
                </span>
                {/* <span className="ms-auto !text-3xl">{currentOpenIndex === 1 ? "–" : "+"}</span> */}
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 4 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <TableNo18 />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey="How has male employment in Utah's manufacturing sector evolved over the past year?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(5, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 5 ? null : 5);
                setExpandedQuestion(
                  "How has male employment in Utah's manufacturing sector evolved over the past year?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  5. How has male employment in Utah's manufacturing sector
                  evolved over the past year?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 5 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <TableNo19 />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey="What trends are observed in the share of female workers in the Utah manufacturing sector?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(6, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 6 ? null : 6);
                setExpandedQuestion(
                  "What trends are observed in the share of female workers in the Utah manufacturing sector?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  6. What trends are observed in the share of female workers in
                  the Utah manufacturing sector?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 6 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <TableNo20 />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey="What is the total count of male employees in the Utah manufacturing workforce in 2024?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(7, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 7 ? null : 7);
                setExpandedQuestion(
                  "What is the total count of male employees in the Utah manufacturing workforce in 2024?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  7. What is the total count of male employees in the Utah
                  manufacturing workforce in 2024?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 7 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <TableNo23 />
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Tab>

        {/* Age Analysis */}

        <Tab eventKey="Age Analysis" title="Age Analysis" id="Age-Analysis">
          {/* <Accordion defaultActiveKey={['0']} alwaysOpen className="w-full"> */}
          <Accordion>
            <Accordion.Item
              eventKey="What is the percentage share of males and females in each age group during 2024?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(8, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 8 ? null : 8);
                setExpandedQuestion(
                  "What is the percentage share of males and females in each age group during 2024?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  1. What is the percentage share of males and females in each
                  age group during 2024?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 8 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <TableNo10 />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey="What is the total number of workers across all age groups?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(9, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 9 ? null : 9);
                setExpandedQuestion(
                  "What is the total number of workers across all age groups?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  2. What is the total number of workers across all age groups?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 9 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <TableNo21 />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey=" What percentage of the total workforce is female across all age groups?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(10, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 10 ? null : 10);
                setExpandedQuestion(
                  " What percentage of the total workforce is female across all age groups?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  3. What percentage of the total workforce is female across all
                  age groups?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 10 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <TableNo22 />
              </Accordion.Body>
            </Accordion.Item>

            {/* <Accordion.Item
              eventKey="What is the Age Profile for Female in Manufacturing versus Male?"
              // className="pb-3"
              onClick={() =>
                setExpandedQuestion(
                  "What is the Age Profile for Female in Manufacturing versus Male?"
                )
              }
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  4. What is the Age Profile for Female in Manufacturing versus
                  Male?
                </span>
                   <span className="ms-auto !text-3xl">{currentOpenIndex === 1 ? "–" : "+"}</span>
              </Accordion.Header>
              <Accordion.Body>
                <ShareChart5 />
              </Accordion.Body>
            </Accordion.Item> */}

            <Accordion.Item
              eventKey="Which age group has the highest number of male workers?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(11, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 11 ? null : 11);
                setExpandedQuestion(
                  "Which age group has the highest number of male workers?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  4. Which age group has the highest number of male workers?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 11 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <TableNo24 />
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item
              eventKey="How does male employment differ between the 14-18 and 22-24 age groups in the year 2024?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(12, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 12 ? null : 12);
                setExpandedQuestion(
                  "How does male employment differ between the 14-18 and 22-24 age groups in the year 2024?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  5. How does male employment differ between the 14-18 and 22-24
                  age groups in the year 2024?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 12 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <TableNo25 />
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item
              eventKey=" Which age group has the highest percentage of female workers in 2024?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(13, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 13 ? null : 13);
                setExpandedQuestion(
                  " Which age group has the highest percentage of female workers in 2024?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  6. Which age group has the highest percentage of female
                  workers in 2024?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 13 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                {/* <TableNo26/> */}
                {/* <ShareChart5/> */}
                <TableNo26 />
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item
              eventKey="Which age group shows the largest gender disparity in terms of employment?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(14, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 14 ? null : 14);
                setExpandedQuestion(
                  "Which age group shows the largest gender disparity in terms of employment?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  7. Which age group shows the largest gender disparity in terms
                  of employment?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 14 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                {/* <TableNo27/> */}
                <TableNo27 />
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item
              eventKey="What is the overall percentage share of male workers in the manufacturing sector across all age groups during 2024?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(15, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 15 ? null : 15);
                setExpandedQuestion(
                  "What is the overall percentage share of male workers in the manufacturing sector across all age groups during 2024?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  8. What is the overall percentage share of male workers in the
                  manufacturing sector across all age groups during 2024?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 15 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <TableNo28 />
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item
              eventKey="What age group represents the smallest share of total employment in the year 2024?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(16, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 16 ? null : 16);
                setExpandedQuestion(
                  "What age group represents the smallest share of total employment in the year 2024?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  9. What age group represents the smallest share of total
                  employment in the year 2024?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 16 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <TableNo29 />
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item
              eventKey="What is the female-to-male ratio for each age group in manufacturing employment during 2024?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(17, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 17 ? null : 17);
                setExpandedQuestion(
                  "What is the female-to-male ratio for each age group in manufacturing employment during 2024?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  10. What is the female-to-male ratio for each age group in
                  manufacturing employment during 2024?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 17 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <TableNo30 />
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Tab>

        {/* Race Analysis */}

        <Tab eventKey="Race Analysis" title="Race Analysis" id="Race-Analysis">
          <Accordion>
            <Accordion.Item
              eventKey="How does the distribution of employment share compare across different race groups in 2024?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(18, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 18 ? null : 18);
                setExpandedQuestion(
                  "How does the distribution of employment share compare across different race groups in 2024?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  1. How does the distribution of employment share compare
                  across different race groups in 2024?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 18 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <TableNo11 />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey="What is the ratio of employment counts for 2018 vs 2024 for each race group?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(19, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 19 ? null : 19);
                setExpandedQuestion(
                  "What is the ratio of employment counts for 2018 vs 2024 for each race group?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  2. What is the ratio of employment counts for 2018 vs 2024 for
                  each race group?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 19 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <TableNo16 />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey="What is the percentage change in employment share for each race group from 2018 to 2024?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(20, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 20 ? null : 20);
                setExpandedQuestion(
                  "What is the percentage change in employment share for each race group from 2018 to 2024?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  3. What is the percentage change in employment share for each
                  race group from 2018 to 2024?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 20 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <TableNo13 />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey="Which race group had the largest decrease in employment compared to 2018 and 2024?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(21, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 21 ? null : 21);
                setExpandedQuestion(
                  "Which race group had the largest decrease in employment compared to 2018 and 2024?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  4. Which race group had the largest decrease in employment
                  compared to 2018 and 2024?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 21 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <TableNo33 />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey="How does the overall employment trend in manufacturing reflect diversity changes between 2018 and 2024?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(22, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 22 ? null : 22);
                setExpandedQuestion(
                  "How does the overall employment trend in manufacturing reflect diversity changes between 2018 and 2024?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  5. How does the overall employment trend in manufacturing
                  reflect diversity changes between 2018 and 2024?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 22 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <TableNo14 />
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Tab>

        {/* Education Analysis */}

        <Tab
          eventKey="Education Analysis"
          title="Education Analysis"
          id="Education-Analysis"
        >
          <Accordion>
            <Accordion.Item
              eventKey="How has the percentage share of female in manufacturing changed from 2018 to 2024 across different education levels?"
              onClick={() => {
                handleSetOpen(23, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 23 ? null : 23);
                setExpandedQuestion(
                  "How has the percentage share of female in manufacturing changed from 2018 to 2024 across different education levels?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  1. How has the percentage share of female in manufacturing
                  changed from 2018 to 2024 across different education levels?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 23 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <TableNo12 />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey="Which education level saw the largest increase in female employment in the manufacturing sector between 2018 and 2024?"
              onClick={() => {
                handleSetOpen(24, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 24 ? null : 24);
                setExpandedQuestion(
                  "Which education level saw the largest increase in female employment in the manufacturing sector between 2018 and 2024?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  2. Which education level saw the largest increase in female
                  employment in the manufacturing sector between 2018 and 2024?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 24 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <TableNo31 />
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item
              eventKey="Which gender has shown a higher growth rate in employment in the manufacturing sector for individuals with a high school education?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(25, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 25 ? null : 25);
                setExpandedQuestion(
                  "Which gender has shown a higher growth rate in employment in the manufacturing sector for individuals with a high school education?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  3. Which gender has shown a higher growth rate in employment
                  in the manufacturing sector for individuals with a high school
                  education?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 25 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <TableNo32 />
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Tab>

        {/* Ethinicity Analysis */}

        <Tab
          eventKey="Ethnicity Analysis"
          title="Ethnicity Analysis"
          id="Ethnicity-Analysis"
        >
          <Accordion>
            <Accordion.Item
              eventKey="Which ethnic group had the largest decrease in employment share percentage between 2018 and 2024?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(26, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 26 ? null : 26);
                setExpandedQuestion(
                  "Which ethnic group had the largest decrease in employment share percentage between 2018 and 2024?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  1. Which ethnic group had the largest decrease in employment
                  share percentage between 2018 and 2024?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 26 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <TableNo15 />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey="Which ethnic group had the lowest growth in employment numbers from 2018 to 2024?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(27, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 27 ? null : 27);

                setExpandedQuestion(
                  "Which ethnic group had the lowest growth in employment numbers from 2018 to 2024?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  2. Which ethnic group had the lowest growth in employment
                  numbers from 2018 to 2024?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 27 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <TableNo34 />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey="How does the change in employment numbers for Hispanic or Latino workers compare to the overall change for all ethnicities between 2018 and 2024?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(28, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 28 ? null : 28);
                setExpandedQuestion(
                  "How does the change in employment numbers for Hispanic or Latino workers compare to the overall change for all ethnicities between 2018 and 2024?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  3. How does the change in employment numbers for Hispanic or
                  Latino workers compare to the overall change for all
                  ethnicities between 2018 and 2024?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 28 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <TableNo35 />
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Tab>

        {/* Industry Analysis */}

        <Tab
          eventKey="Industry Analysis"
          title="Industry Analysis"
          id="Industry-Analysis"
        >
          <Accordion>
            <Accordion.Item
              eventKey="What is the trend in employment counts for the Aerospace Product and Parts Manufacturing sector from 2018 to 2024?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(29, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 29 ? null : 29);
                setExpandedQuestion(
                  "What is the trend in employment counts for the Aerospace Product and Parts Manufacturing sector from 2018 to 2024?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  1. What is the trend in employment counts for the Aerospace
                  Product and Parts Manufacturing sector from 2018 to 2024?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 29 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <TableNo36 />
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item
              eventKey="Which manufacturing industry sector had the highest number of employees in 2024?"
              // className="pb-3"
              onClick={() => {
                handleSetOpen(30, currentOpenIndex);
                setCurrentOpenIndex(currentOpenIndex === 30 ? null : 30);
                setExpandedQuestion(
                  "Which manufacturing industry sector had the highest number of employees in 2024?"
                );
              }}
            >
              <Accordion.Header className="custom-accordion-header">
                <span className="accordion-title">
                  2. Which manufacturing industry sector had the highest number
                  of employees in 2024?
                </span>
                <span className="ms-auto !text-3xl">
                  {currentOpenIndex === 30 ? "–" : "+"}
                </span>
              </Accordion.Header>
              <Accordion.Body>
                <TableNo37 />
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </Tab>
      </Tabs>
    </div>
  );
};
